import {Component, 
    OnInit, 
    ElementRef, 
    ViewChildren, 
    ViewChild, 
    ChangeDetectionStrategy, 
    ChangeDetectorRef, 
    Inject, 
	ViewRef
} 
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
// RXJS
import { BehaviorSubject, ReplaySubject } from 'rxjs';
//Service
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { KeHoachSanXuatService } from '../ke-hoach-san-xuat-service/ke-hoach-san-xuat.service';
//Model
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { KeHoachSanXuat, KhKeHoachSanXuatInteraction } from '../ke-hoach-san-xuat-model/ke-hoach-san-xuat.model';

@Component({
	selector: 'm-xac-nhan-huy-dialog',
	templateUrl: './xac-nhan-huy-dialog.component.html',
	styleUrls: ['../ke-hoach-san-xuat.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class XacNhanHuyComponent implements OnInit{
    /*Config Form */
    CONFIG: CommonConFig;

    /* Loading.... */
    loadingSubject = new BehaviorSubject<boolean>(false);
    loading$ = this.loadingSubject.asObservable();
    /* ------------------------------------------------------------------ */

    /* Extend field:  */
    title: string = '';					// Tiêu đề dialog
    viewLoading: boolean = false;   	// Loading khi mở dialog
	dataApprove: KhKeHoachSanXuatInteraction;
	disableButton: boolean = false;
	disableDuyetButton: boolean = false;
	isDuyetHuy: boolean = false;
    /* ------------------------------------------------------------------ */
    
    /* Các Sub form trên dialog:  */
	Form: FormGroup;
	Duyet: FormGroup;				     
    /* ------------------------------------------------------------------ */

    constructor(
        public dialogRef: MatDialogRef<XacNhanHuyComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dungChungService: DungChungService,
        private services: KeHoachSanXuatService,
		private HHFB: FormBuilder,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
    ) { 
		this.dialogRef.disableClose = true;
    }

    /*---------------------------- LOAD DATA --------------------------------*/
    ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.dataApprove = this.data.data;
		if(this.data.isDuyetHuy != null){
			this.isDuyetHuy = this.data.isDuyetHuy;
		}
		/*create form */
		this.createForm();

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			this.changeDetectView();
		});

    }
    /* -----------------------------------------------------------------------*/


    /*----------------- Create Form with appropriate sub forms ---------------*/
    createForm(){
		/*Group các Form */
		this.Form = this.HHFB.group({
			SoPhieu: [KeHoachSanXuat.CATEGORY + this.dataApprove.Id],
			TenKhachHang: [this.dataApprove.TenKhachHang],
			SoPhieuDHB: [this.dataApprove.SoPhieuDatHang],
			MaTP: [this.dataApprove.MaHangTP],
			TenTP: [this.dataApprove.TenHangTP],
			SLSX: [this.f_number(this.dataApprove.SoLuongSanXuat)],
			NgaySanXuat: [this.getFormatDate(this.dataApprove.NgaySanXuat)],
			GiaiDoan: [this.dataApprove.TenGiaiDoan],
			NSTB: [this.f_number(this.dataApprove.NSTB)],
			CNHC: [this.f_number(this.dataApprove.CNHC)],
			CNTC: [this.f_number(this.dataApprove.CNTC)],
            LyDo: ['',Validators.required]
		});
		
		this.Form.disable();
		if(!this.isDuyetHuy){
			this.Form.controls["LyDo"].enable();
		}
		else{
			this.Form.controls["LyDo"].setValue(this.dataApprove.GhiChu);

			var tenNguoiLap = '';
			this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
			
			var idUser = '';
			this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });

			this.Duyet = this.HHFB.group({
				NguoiXacNhan: [tenNguoiLap],
				NgayXacNhan: [this.getFormatDate(moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS'))],
				KetQUaDuyet: ['1'],
				LyDo: [''],
			})

			/*Disable các trường dữ liệu không thay đổi */
			this.Duyet.controls["NguoiXacNhan"].disable();
			this.Duyet.controls["NgayXacNhan"].disable();
		}
        this.changeDetectView();
    }
    /* -----------------------------------------------------------------------*/

    /*---------------------------- Thao tác trên form ------------------------*/
    back(){
		this.dialogRef.close({ 
			isChange: this.disableButton,
			isDuyet: this.disableDuyetButton,
			data: this.dataApprove
		});
    }
	sendApprove(){
		const controls = this.Form.controls;

		if (this.Form.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		const dialogRef = this.layoutUtilsService.POP02('');
		const _deleteMessage = `Gửi duyệt thành công`;
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			this.dataApprove.GhiChu = this.Form.controls["LyDo"].value;
			
			this.services.huyDuyet(this.dataApprove).subscribe(res => {
				if (res.status == 1) {
					this.layoutUtilsService.showInfo(_deleteMessage);
					this.Form.disable();
					this.disableButton = true;
					this.changeDetectView();
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});	
		});
	}
	saveItemDuyet(){
		const controls = this.Duyet.controls;

		if (this.Duyet.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		const dialogRef = this.layoutUtilsService.POP02('');
		const _deleteMessage = `Duyệt phiếu thành công`;
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			this.dataApprove.isDuyet = (+this.Duyet.controls["KetQUaDuyet"].value == 1) ? true : false;
			this.dataApprove.LyDoDuyet = this.Duyet.controls["LyDo"].value;
			
			this.services.duyetHuy(this.dataApprove).subscribe(res => {
				if (res.status == 1) {
					this.layoutUtilsService.showInfo(_deleteMessage);
					this.Duyet.disable();
					this.disableDuyetButton = true;					
					this.changeDetectView();
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});	
		});
	}

	changeKetQuaDuyet(){
		if(+this.Duyet.controls["KetQUaDuyet"].value == 2){
			this.Duyet.controls["LyDo"].setValidators([Validators.required]);
			this.Duyet.controls['LyDo'].updateValueAndValidity()
		}
		else if(+this.Duyet.controls["KetQUaDuyet"].value == 1){
			this.Duyet.controls["LyDo"].setValidators([]);
			this.Duyet.controls['LyDo'].updateValueAndValidity()
		}
	}
	isKhongDuyet(){
		return +this.Duyet.controls["KetQUaDuyet"].value == 2;
	}
	/* -----------------------------------------------------------------------*/
	
	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG SỐ -----------------------*/
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
	/* -----------------------------------------------------------------------*/


	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG NGÀY -----------------------*/
	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------------ Extend Options --------------------------*/
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/* -----------------------------------------------------------------------*/

	
}